import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DesktopTower, X, Info } from '@phosphor-icons/react';

const STORAGE_KEY = 'aafaq_mobile_notice_dismissed_v1';

const MobileNotice = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Force-show via ?mobile_notice=1 (used for visual verification)
    const forced = new URLSearchParams(window.location.search).get('mobile_notice') === '1';
    const mq = window.matchMedia('(max-width: 768px)').matches;
    const ua = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');
    const isMobile = mq || ua;
    const dismissed = localStorage.getItem(STORAGE_KEY) === '1';
    if ((forced || isMobile) && (forced || !dismissed)) {
      const t = setTimeout(() => setShow(true), 700);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="mobile-notice-banner"
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 360, damping: 32 }}
          dir="rtl"
          className="fixed top-0 inset-x-0 z-[60] bg-[#1F3D2B] text-white shadow-lg"
        >
          <div className="max-w-6xl mx-auto px-4 py-3 flex items-start gap-3">
            <div className="shrink-0 w-9 h-9 rounded-full bg-[#4A641F] flex items-center justify-center mt-0.5">
              <DesktopTower size={20} weight="duotone" />
            </div>
            <div className="flex-1 text-sm leading-7">
              <p className="font-bold text-[#E8EDD9] mb-0.5 flex items-center gap-1.5">
                <Info size={16} weight="fill" className="text-[#C8D4B8]" />
                لتجربة أفضل
              </p>
              <p className="text-[#D8E0C9] text-xs leading-6">
                ننصح بتصفّح الموقع من جهاز كمبيوتر للاطلاع على المنتجات والأدوات بشكل أوضح.
              </p>
            </div>
            <button
              onClick={dismiss}
              data-testid="mobile-notice-dismiss"
              aria-label="إغلاق التنبيه"
              className="shrink-0 w-8 h-8 rounded-full hover:bg-white/10 flex items-center justify-center transition-colors"
            >
              <X size={18} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileNotice;
